import Error from "@mui/icons-material/Error";
import { styled } from "@mui/material/styles";

const StyledError = styled(Error)({
    color: "red",
    fontSize: "18px",
    verticalAlign: "text-bottom",
});

const ErrorIcon = (props) => <StyledError data-testid="ErrorIcon" {...props} />;

export default ErrorIcon;
